import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gb-meeting',
  templateUrl: './gb-meeting.component.html',
  styleUrls: ['./gb-meeting.component.scss']
})
export class GbMeetingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
